"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveNotchPosition = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
function resolveNotchPosition(position) {
    var splPosition = position
        .split('_')
        .reduce(function (c, p) {
        var _a;
        return (__assign(__assign({}, c), (_a = {}, _a[p.toLowerCase()] = 0, _a)));
    }, {});
    switch (position) {
        case 'TOP_RIGHT':
            return __assign(__assign({}, splPosition), { borderTopRightRadius: 'inherit', borderTopLeftRadius: 0, borderBottomRightRadius: 0, borderBottomLeftRadius: '100%', padding: '0.375rem 0.375rem 0.875rem 1rem' });
        case 'TOP_LEFT':
            return __assign(__assign({}, splPosition), { borderTopRightRadius: 0, borderTopLeftRadius: 'inherit', borderBottomRightRadius: '100%', borderBottomLeftRadius: 0, padding: '0.375rem 1rem 0.875rem 0.375rem' });
        case 'BOTTOM_LEFT':
            return __assign(__assign({}, splPosition), { borderTopRightRadius: '100%', borderTopLeftRadius: 0, borderBottomRightRadius: 0, borderBottomLeftRadius: 'inherit', padding: '0.875rem 1rem 0.375rem 0.375rem' });
        case 'BOTTOM_RIGHT':
            return __assign(__assign({}, splPosition), { borderTopRightRadius: 0, borderTopLeftRadius: '100%', borderBottomRightRadius: 'inherit', borderBottomLeftRadius: 0, padding: '0.875rem 0.375rem 0.375rem 1rem' });
    }
}
exports.resolveNotchPosition = resolveNotchPosition;
function ILNotch(_a) {
    var _b = _a.color, color = _b === void 0 ? 'inherit' : _b, _c = _a.position, position = _c === void 0 ? 'TOP_RIGHT' : _c, _d = _a.textColor, textColor = _d === void 0 ? 'primary.contrastText' : _d, children = _a.children, className = _a.className, sx = _a.sx;
    var splPosition = resolveNotchPosition(position);
    var classes = 'il-notch ' + className;
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: __assign(__assign(__assign(__assign({}, sx), { position: 'absolute' }), splPosition), { backgroundColor: color }) },
        react_1.default.createElement(material_1.Typography, { sx: {
                fontSize: '20px',
                lineHeight: 1.2,
                fontWeight: 800,
                color: textColor,
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
            } },
            react_1.default.createElement("span", __assign({}, (!children && { style: { minWidth: 18, minHeight: 20 } })), children))));
}
exports.default = ILNotch;
